import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as MySVG } from '../images/mappa e wayfinding.svg';

const useStyles = makeStyles((theme) => ({
  mapcontainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F5F5F5',
    width: '100%',
    height: '100%',
    borderRadius: '20px 20px 0px 20px',
    opacity: 1,
    overflow: 'hidden',
  },
  svgcontainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  svg: {
    width: '100%',
    height: '100%',
    //objectFit: 'contain', 
  },
}));

const MapDisplay = ({ currentLabel }) => {
  const classes = useStyles();
  const svgRef = useRef(null);

  useEffect(() => {
    const showElementById = (searchId) => {
      if (!searchId) return;

      const formattedId = searchId.replace(/[\s+]+/g, '_');
      const svgElement = svgRef.current;

      if (svgElement) {
        const percorsoSalaElements = svgElement.querySelectorAll('.percorso_sala');
        percorsoSalaElements.forEach(element => {
          element.style.display = 'none';
        });

        const elementToShow = svgElement.querySelector(`#${formattedId}.percorso_sala`);
        if (elementToShow) {
          elementToShow.style.display = 'block';
        }
      }
    };

    showElementById(currentLabel);
  }, [currentLabel]);

  return (
    <div className={classes.mapcontainer}>
      <div className={classes.svgcontainer}>
      <MySVG ref={svgRef} className={classes.svg} />
      </div>
      
    </div>
  );
};

MapDisplay.propTypes = {
  currentLabel: PropTypes.string.isRequired,
};

export default MapDisplay;
